import { useEffect, useMemo, useRef, useState } from "react";
import { MathEditorButton } from "../../../../shared/ui/MathEditor/MathButton";
import MathEditor from "../../../../shared/ui/MathEditor/MathEditor";

export function TextField({ onChange, style, value, id }) {
  const [open, setOpen] = useState(false);
  const inputRef = useRef();
  return (
    <>
      <div className="text-field">
        <div
          id={id}
          className={'field-input'}
          contentEditable={true}
          style={style}
          onInput={(e) => {
            onChange(e.currentTarget.innerText);
          }}
        ></div>
        <MathEditorButton setOpen={() => setOpen(true)} />
      </div>
      {open ? (
        <MathEditor
          closeEditor={() => setOpen(false)}
          initialHtml={value}
          saveEditor={(value) => {    
            const field = document.querySelector(`#${id}`);
            if(field){
              field.innerHTML = value;
            }
            onChange(value);
            setTimeout(() => {
              if (window.MathJax) {
                window.MathJax.typesetPromise();
              }
            }, 300);
            setOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
